import { IconButton, Tooltip, withStyles } from "@material-ui/core";
import { ChatBubble, Info, Mail } from "@material-ui/icons";
import React, { useState } from "react";
import { FunctionField } from "react-admin";
import { useAppDataProvider } from "../../../../src/dataprovider";
import { WaitingResponseType } from "../../../../src/Enums/WaitingResponseType";

const HtmlTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}))(Tooltip);

const RefNoField = props => {
  return <FunctionField label={"REF NO"} render={record => <RefNoFunctionField record={record} />} />;
};

const RefNoFunctionField = props => {
  const { record } = props;
  const dataProvider = useAppDataProvider();
  const [rejectedRefNo, setRejectedRefNo] = useState();

  React.useEffect(() => {
    if (props.record.parentRejectionOrderId != null) {
      dataProvider
        .getOne("pbhrequestorders/", {
          id: props.record.parentRejectionOrderId,
        })
        .then(response => {
          setRejectedRefNo(response.data.refNo);
        });
    }
  }, []);

  const HtmlTooltip = props => <Tooltip {...props} />;

  const getWaitingResponseIcon = () => {
    if (record?.pbhWaitingResponseStatus === WaitingResponseType.WaitingResponseFromCustomer) {
      return (
        <HtmlTooltip title="Waiting Response from Customer">
          <IconButton size="small" style={{ padding: 2 }}>
            <Mail style={{ color: "goldenrod" }} />
          </IconButton>
        </HtmlTooltip>
      );
    }
    if (record?.pbhWaitingResponseStatus === WaitingResponseType.Responded) {
      return (
        <HtmlTooltip title="Responded">
          <IconButton size="small" style={{ padding: 2 }}>
            <Mail style={{ color: "#22b02e" }} />
          </IconButton>
        </HtmlTooltip>
      );
    }
    return null;
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        transition: "background-color 0.5s",
        padding: "8px",
      }}
    >
      {getWaitingResponseIcon()}
      <>{record.refNo}</>
      {(record.isRejectionOrder || record.isReplenishmentRejectionOrder) && (
        <HtmlTooltip title={record.isRejectionOrder ? "Rejection Order" : "Replenishment Rejection Order"}>
          <IconButton color="primary" style={{ fontSize: "0.75rem" }}>
            {rejectedRefNo}
            <Info />
          </IconButton>
        </HtmlTooltip>
      )}
      {record.isHardTime && (
        <IconButton>
          <Tooltip title="This component is hard time">
            <ChatBubble />
          </Tooltip>
        </IconButton>
      )}
    </div>
  );
};

export default RefNoField;
